import React, { useState, useEffect, useMemo } from 'react';
import { ActiveEditContainer } from './styles';
import { get, last } from 'global/lib/lodash';
import { getId } from './utils';
import { SystemScore } from './SystemScore';

let ISUPDATING = false;
let NEEDSUPDATE = false;

const searchChildren = (children, id) => {
  const childs = children || [];
  let found = childs.find((c) => getId(c) == id);

  if (found) {
    return found;
  }
  for (let i = 0; i < childs.length; i++) {
    found = searchChildren(childs[i].children, id);
    if (found) {
      return found;
    }
  }
  return found;
};

export const ActiveEdit = (props) => {
  const { activeEdit, assessment, setSidebarOpen, setActiveEdit, updateScores, setCurrentAnchor, treedProcessedScoreData, selectedItems, filter, scorecard, isCourse } = props;
  const [state, setState] = useState({
    needsUpdate: false,
    isUpdating: false,
  });

  const setNeedUpdate = () => {
    NEEDSUPDATE = true;
  };

  // Resolve during render so the checklist node (and its id) exists on the first
  // paint — otherwise enter-edit scrolls before the header is in the DOM.
  const { pssvSystem, pssvChecklist, next, prev } = useMemo(() => {
    if (!activeEdit) {
      return { pssvSystem: {}, pssvChecklist: undefined, next: undefined, prev: undefined };
    }

    const pssvSystem = searchChildren(treedProcessedScoreData, getId(activeEdit.pssvSystem));
    const pssvChecklist = searchChildren(treedProcessedScoreData, getId(activeEdit.pssvChecklist));
    const pSystemIndex = treedProcessedScoreData.findIndex((t) => getId(t) === getId(pssvSystem));
    const checklists = get(pssvSystem, 'children', []);
    const currentIndex = checklists.findIndex((f) => getId(f) === getId(get(activeEdit, 'pssvChecklist')));
    const nextSystem = get(treedProcessedScoreData, pSystemIndex + 1);
    const prevSystem = get(treedProcessedScoreData, pSystemIndex - 1);

    return {
      pssvSystem,
      pssvChecklist,
      next: currentIndex === -1 ? undefined : get(checklists, currentIndex + 1, { ...get(nextSystem, 'children.0'), _system: nextSystem }),
      prev: currentIndex === -1 ? undefined : get(checklists, currentIndex - 1, { ...last(get(prevSystem, 'children', [])), _system: prevSystem }),
    };
  }, [treedProcessedScoreData, activeEdit]);

  useEffect(() => {
    return () => {
      if (NEEDSUPDATE && !ISUPDATING) {
        ISUPDATING = true;
        setState((s) => ({ ...s, isUpdating: true }));
        updateScores(null, true)
          .then(() => {
            NEEDSUPDATE = false;
          })
          .finally(() => {
            ISUPDATING = false;
            setState((s) => ({ ...s, isUpdating: false }));
          });
      }
    };
  }, [activeEdit]);

  const _props = {
    ...props,
    next,
    prev,

    ...state,

    setSidebarOpen,
    setActiveEdit,
    activeEdit,
    setCurrentAnchor,
    updateScores,
    selectedItems,
    filter,
    scorecard,
    setNeedUpdate,

    isCourse,
    assessment,
    pssvSystem,
    pssvChecklist,
  };

  return (
    <ActiveEditContainer>
      <SystemScore {..._props} />
    </ActiveEditContainer>
  );
};
